export default __webpack_public_path__ + "static/media/9.35836ea9.jpg";